import { Box, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import theme from "../../theme/theme";
import { capitalizeFirstLetter } from "../../utils/strings";

export default function Page404() {
  return (
    <Stack
      sx={{ height: "100vh", justifyContent: "center", alignItems: "center" }}
    >
      <Box>
        {/* <img src={image_404} alt="Page not found" /> */}
        <Typography variant="h5" sx={{ color: theme.colors.primary }}>
          {capitalizeFirstLetter(i18n.t("page_not_found"))}
        </Typography>
      </Box>
    </Stack>
  );
}
